import React from 'react';
import { Card, CardMirror, CardTitle, InfoRow, InfoLabel, InfoValue } from './styles';
var infoFields = [
    {
        label: 'Nombre:',
        getValue: function (ticket) {
            if (ticket.apartment_contact) {
                return ticket.apartment_contact.first_name + " " + ticket.apartment_contact.last_name;
            }
            if (ticket.external_client &&
                ticket.external_client_first_name &&
                ticket.external_client_last_name) {
                return ticket.external_client_first_name + " " + ticket.external_client_last_name;
            }
            return 'Información no disponible';
        },
    },
    {
        label: 'Email:',
        getValue: function (ticket) { var _a; return ((_a = ticket.apartment_contact) === null || _a === void 0 ? void 0 : _a.email) || 'No disponible'; },
    },
    {
        label: 'Telefono:',
        getValue: function (ticket) {
            var _a;
            return ((_a = ticket.apartment_contact) === null || _a === void 0 ? void 0 : _a.mobile) ||
                ticket.external_client_phone ||
                'No disponible';
        },
    },
];
var TicketContactInfo = function (_a) {
    var ticket = _a.ticket, _b = _a.matchTicketInformationStyle, matchTicketInformationStyle = _b === void 0 ? false : _b;
    var CardWrapper = matchTicketInformationStyle ? CardMirror : Card;
    return (React.createElement(CardWrapper, null,
        React.createElement(CardTitle, null, "Informaci\u00F3n del solicitante"),
        infoFields.map(function (field, index) { return (React.createElement(InfoRow, { key: field.label },
            React.createElement(InfoLabel, null, field.label),
            React.createElement(InfoValue, null, field.getValue(ticket)))); })));
};
export default TicketContactInfo;
